var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    /**
     *
     * @param param
     * @constructor
     */
    function Seq(param) {
        this.seq_funs=null;
        if(param){
            if(Util.isArray(param)){
                this.seq_funs=new Array();
                for(var i=0;i<param.length;i++){
                    this.seq_funs.push(param[i]);
                }
            }
            else{
                this.seq_funs=new Array();
                this.seq_funs.push(param);
            }
        }
        else{
            this.seq_funs=new Array();
        }
    }

    function isArray(value){
        if (typeof Array.isArray === "function") {
            return Array.isArray(value);
        }else{
            return Object.prototype.toString.call(value) === "[object Array]";
        }
    }

    Seq.prototype.then=function(param){
        if(isArray(param)){
            for(var i=0;i<param.length;i++){
                this.seq_funs.push(param[i]);
            }
        }
        else{
            this.seq_funs.push(param);
        }
        return this;
    };

    Seq.prototype.first=function(param){
        if(isArray(param)){
            for(var i=param.length-1;i>=0;i--){
                this.seq_funs.unshift(param[i]);
            }
        }
        else{
            this.seq_funs.unshift(param);
        }
        return this;
    };

    Seq.prototype.firstEach=function(items,fun){
        var funs=[];
        for(var i=0;i<items.length;i++){
            funs.push(fun);
        }
        return this.first(funs);
    };

    Seq.prototype.thenEach=function(items,fun){
        var funs=[];
        for(var i=0;i<items.length;i++){
            funs.push(fun);
        }
        return this.then(funs);
    };

    Seq.prototype.run=function(param){
        var fun=this.seq_funs.shift();
        if(fun){
            try{
                fun(this,param);
            }
            catch(e){
                if(this.errorFun)
                    this.errorFun(e);
                else
                    throw e;
            }
        }
    };

    Seq.prototype.resolve=function(param){
        var fun=this.seq_funs.shift();
        if(fun){
            try{
                fun(this,param);
            }
            catch(e){
                if(this.errorFun)
                    this.errorFun(e);
                else
                    throw e;
            }
        }
    };

    Seq.prototype.reject=function(e){
        if(this.errorFun)
            this.errorFun(e);
        else
            throw e;
    };

    Seq.prototype.onerror=function(fun){
        this.errorFun=fun;
        return this;
    };

    $m.Seq=Seq;
})(HebcaMiddleware);
